import type { ReactNode } from 'react';
import { Flex } from '@kognitos/lattice';

interface ISidebarRowContentProps {
  /** Rendered inside the fixed-width icon column. */
  icon: ReactNode;
  label: string;
  isCollapsed: boolean;
}

/**
 * The inside of a sidebar row: a fixed icon column plus a truncating label that
 * hides when the rail is collapsed. Shared by the nav entries, Help and
 * Notifications so every row's icon lands on the same vertical axis.
 *
 * @param {ISidebarRowContentProps} props - Component props
 * @returns {JSX.Element} The row's icon and label
 */
export function SidebarRowContent({
  icon,
  label,
  isCollapsed,
}: ISidebarRowContentProps) {
  return (
    <>
      <Flex
        align="center"
        justify="center"
        className="app-sidebar-row-icon w-10 shrink-0"
      >
        {icon}
      </Flex>
      {!isCollapsed && (
        <span className="app-sidebar-row-label min-w-0 flex-1 truncate">
          {label}
        </span>
      )}
    </>
  );
}

export default SidebarRowContent;
